﻿var useCaptchaLogin = true;
window.useCaptchaLogin = useCaptchaLogin;

/* exported whl */
var whl =
{
    doLogin: function(res, callback, platformJWT)
    {
        /* jshint maxcomplexity: 12, maxstatements: 35 */
        'use strict';

        var result = {};
        var country;
        var response = JSON.parse(res) || eval(res);
        var error = response.Error;
        var forgotPasswordPopupHref = document.getElementById('forgotYourPass_a');
        delete PlatformJWTManager.twostepJWTToken;

        if (res == '[]')
        {
            result.status = 'failure';
            result.message = ($string('Login').WrongUserNameOrPassword);
        }
        else if (response.restrictedEmailIsVerified)
        {
            result.status = 'restrictedEmailIsVerified';
            result.message = response.restrictedEmailIsVerified;
        }
        else if (response.lockedUserAccount) {
            result.status = 'lockedUserAccount';
            result.message = response.lockedUserAccount;
        }
        else if (response.KYCAutoFreezed)
        {
            result.status = 'KYCAutoFreezed';
            result.message = response.KYCAutoFreezed;
        }
        else if (!error)
        {
            // success
            /* jshint evil: true */
            result = eval(res);
            /* jshint evil: false */

            result.status = 'success';
            result.platformJWT = platformJWT;
        }
        else if (error.indexOf('restrictedCountry') != -1)
        {
            country = error.split(':')[1];
            result.status = 'restrictedCountry';
			var restricterCountryText = country ? $string('Login').LoginRestrictedPart2 + country + '\n\r' : '';
            result.message = ($string('Login').LoginRestrictedPart1 + '\n\r' + restricterCountryText + $string('Login').LoginRestrictedPart3);
        }
        else if (error.indexOf('restrictedRegion') != -1)
        {
            var region = error.split(':')[1];
            result.status = 'restrictedRegion';
            result.message = ($string('Login').LoginRestrictedPart1 + '\n\r' + $string('Login').LoginRestrictedPart5 + region + '\n\r' + $string('Login').LoginRestrictedPart6);
        }
        else if (error.indexOf('restrictedAccount') != -1)
        {
            /////var reason = error.split(':')[1];
            result.status = 'restrictedAccount';
            result.message = $string('Login').AccountRestricted;
        }
        else if (error.indexOf('restrictedLegalText') != -1)
        {
            // Legal text regulations - Two-step login result
            result.status = 'twostep';
            result.token = error.split(':')[1];
            PlatformJWTManager.twostepJWTToken = platformJWT;
        }
        else if (error.indexOf('restricted') != -1)
        {
            country = error.split(':')[1];
            result.status = 'restrictedCountry';
			var restricterCountryText = country ? $string('Login').LoginRestrictedPart2 + country + '\n\r' : '';
            result.message = ($string('Login').LoginRestrictedPart1 + '\n\r' + restricterCountryText + $string('Login').LoginRestrictedPart3);
        }
        else if (error.indexOf('migrationRestricted') != -1)
        {
            result.status = 'migrationRestricted';
            result.loginToken = error.split(':')[1];
            result.message = '';
            PlatformJWTManager.twostepJWTToken = platformJWT;
        }
        else if (error.indexOf('showForgottenPassPopup') != -1 && forgotPasswordPopupHref !== null)
        {
            Application.navigateTo('forgot-password-panel');
        }
        else
        {
            result.status = 'unknown';
            result.message = $string('XSLT').PerformOperationError;
        }

		// Temporary solution. 'modalPOcustom1' is added with a CMS block. This is made for the restrictions of Betrally for Portugal.
		if (typeof modalPOcustom1 !== 'undefined' && modalPOcustom1 && modalPOcustom1 !== undefined && modalPOcustom1 !== null && (result.status == 'success' || result.status == 'twostep')) {
			showmodalPOcustom1();
		}

        callback(result);
    },

    mobileLogin: function (username, password, callback, loginFailedCallback)
    {
        'use strict';

        PageMethods.Login(username, password,
            function(res)
            {
                whl.doLogin(res, callback);
            },
            function()
            {
                alert($string('General').ServerError);
                executeEvents(loginFailedCallback);
            }
        );
    },

    jwtLogin: function (token, callback, loginFailedCallback) {
        'use strict';

         AsyncWebMethods.JwtTokenLogin(token,
            function (res)
            {
                whl.doLogin(res, callback, token);
            },
            function ()
            {
                alert($string('General').ServerError);
                executeEvents(loginFailedCallback);
            }
        );
    },

    /* jshint maxparams: 4 */
    mobileLoginC: function(username, password, captcha, callback, loginFailedCallback)
    {
        'use strict';

        PageMethods.LoginEx(username, password, captcha,
            function(res)
            {
                whl.doLogin(res, callback);
            },
            function()
            {
                alert($string('General').ServerError);
                executeEvents(loginFailedCallback);
            }
        );
    },

    mobileLoginTS: function (token, callback, nativeCallback, loginFailedCallback)
    {
        'use strict';

        AsyncWebMethods.LoginTwoStep(token,
            function(res)
            {
                var twostepJWTToken = PlatformJWTManager.twostepJWTToken;
                whl.doLogin(res, callback, twostepJWTToken);
                executeEvents(nativeCallback);
                //postNativeCallback(nativeCallbackKind.TwoStepLoginSucceed); //Circular dependency
            },
            function()
            {
                alert($string('General').ServerError);
                executeEvents(loginFailedCallback);
            }
        );
    },

    moblieCloseForm: function()
    {
        'use strict';

        page.router.goBack();
    },

    /* jshint unused: false */
    logout: function(callback)
    {
    },

    adminLogin: function(callback)
    {
    },

    formClose: function()
    {
    },

    changePasswordForm: function()
    {
    },

    forgotPasswordForm: function()
    {
    },

    resetPassword: function()
    {
    },

    showDialog: function(url)
    {
    },
    /* jshint unused: true */

    changePassword: function(oldPass, newPass, callback)
    {
        'use strict';

        callback({ status: 'success' });
    },

    refreshSession: function(callback)
    {
        'use strict';

        callback({ status: 'success' });
    },

    status: function(callback)
    {
        'use strict';

        callback({ status: 'success' });
    },

    updateBalance: function(callback)
    {
        'use strict';

        callback();
    },

    getMobileRegistrationURL: function()
    {
        'use strict';

        return this.siteURL + '/MobileRegister.html';
    },

    getMobileBankURL: function()
    {
        'use strict';

        return this.siteURL + '/MobileBank.html';
    },

    getMobilePasswordResetURL: function()
    {
        'use strict';

        return this.siteURL + '/MobileResetPassword.html';
    }
};

if (!window.whl) {
    window.whl = whl;
}

typeof extDict !== "undefined" && extDict['/JSComponents/DirectAPI.ext.js']();
